import { isNil, isEmpty, filter, includes } from 'lodash';

/**
 * RegEx explanation.
 *
 * Looks for two posibilities in the string: either a normal url or a IP + port format.
 *
 * The URL is searched with this half:
 * ^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?
 *
 * At the begining of the string looks for one of [http://wwww.,https://wwww..,http://,https://], then the host name, port if there is and path.
 *
 * The IP + port is searched with this half:
 * ^((http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]){1,3}(:(\d*)\/?(.*))?/.
 *
 * Works similarly but instead of looking for a hostname, it looks for a IP with the format XXX.XXX.XXX.XXX plus the port and the rest of the path if there is onw.
 */
// eslint-disable-next-line no-useless-escape
const EXPRESION = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?|^((http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]){1,3}(:(\d*)\/?(.*))?/;
const REGEX = new RegExp(EXPRESION);
const SERVICE_EXCEPTION = 'ServiceException';
const EXCEPTION_REPORT = 'ExceptionReport';

/**
 * Fetch the CSV stored in the URL.
 *
 * @async
 * @param {string} url - The URL where the CSV is stored.
 * @returns {object} The csv file stored in the URL.
 * @throws {Error} If something goes wrong.
 */

const loadCSVFromURL = async url => {
  try {
    if (isEmpty(url)) throw new Error('The url is empty');
    if (!url.match(REGEX)) throw new Error('No identifiable url');

    const response = await fetch(url, {
      mode: 'cors',
      credentials: 'omit',
      referrerPolicy: 'no-referrer'
    });

    if (response.ok) {
      const rawCSV = await response.text();
      const filteredCSV = filter(rawCSV.split('\n'), row => !isEmpty(row));

      if (filteredCSV.length === 0) throw new Error('CSV not found');
      if (filteredCSV.length === 1) throw new Error('The CSV found has only 1 row');
      if (includes(rawCSV, SERVICE_EXCEPTION) || includes(rawCSV, EXCEPTION_REPORT))
        throw new Error('Service Exception');
      if (isNil(rawCSV)) throw new Error('Empty Response');

      return rawCSV;
    }
    throw new Error('Network response was not ok. Server Error');
  } catch (error) {
    throw new Error(error.message);
  }
};

export default loadCSVFromURL;
